// src/components/Resume.js
import React from 'react';

const Books = () => {
  return (
    <div>
      <h1>Books Page</h1>
      <p>This is the resume page content.</p>
    </div>
  );
};

export default Books;